import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNotifications } from '../../hooks/useNotifications';
import { AssetTypesService } from '../../services/assetTypesService';

const useAssetTypeSelect = ({includeOnlyGeoActive}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [assetsTypes, setAssetsTypes] = useState([]);
  const { showErrorNotification } = useNotifications();

  const getAssetTypes = useCallback(async (search) => {
    setIsLoading(true);
    try {
      const data = await AssetTypesService.getAll({ search, page:1, includeOnlyGeoActive });
      setAssetsTypes(data.assetTypes);
    } catch (error) {
      showErrorNotification({
        title: 'error',
        description: 'errorRetrievingRecords',
      });
    } finally {
      setIsLoading(false);
    }
  }, [showErrorNotification]);

  useEffect(() => {
    getAssetTypes();
  }, []);

  return {
    isLoading,
    getAssetTypes,
    assetsTypes,
  };
};

export default useAssetTypeSelect;

useAssetTypeSelect.propTypes = {
  includeOnlyGeoActive: PropTypes.bool
};